import { jsx as _jsx } from "react/jsx-runtime";
var REACT_ELEMENT_TYPE;

function _jsx2(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

import { Animated, Easing, StyleSheet, View } from 'react-native';
import GenericTouchable, { TOUCHABLE_STATE } from './GenericTouchable';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/**
 * TouchableOpacity bases on timing animation which has been used in RN's core
 */

var _ref = /*#__PURE__*/_jsx2(View, {});

export default class TouchableOpacity extends Component {
  constructor(...args) {
    super(...args);

    this.getChildStyleOpacityWithDefault = () => {
      const childStyle = StyleSheet.flatten(this.props.style) || {};
      return childStyle.opacity == null ? 1 : childStyle.opacity;
    };

    this.opacity = new Animated.Value(this.getChildStyleOpacityWithDefault());

    this.setOpacityTo = (value, duration) => {
      Animated.timing(this.opacity, {
        toValue: value,
        duration: duration,
        easing: Easing.inOut(Easing.quad),
        useNativeDriver: true
      }).start();
    };

    this.onStateChange = (from, to) => {
      if (to === TOUCHABLE_STATE.BEGAN) {
        this.setOpacityTo(this.props.activeOpacity, 0);
      } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        this.setOpacityTo(this.getChildStyleOpacityWithDefault(), 150);
      }
    };
  }

  render() {
    const {
      style = {},
      ...rest
    } = this.props;
    return /*#__PURE__*/_jsx(GenericTouchable, { ...rest,
      style: [style, {
        opacity: this.opacity
      }],
      onStateChange: this.onStateChange,
      children: this.props.children ? this.props.children : _ref
    });
  }

}
TouchableOpacity.defaultProps = { ...GenericTouchable.defaultProps,
  activeOpacity: 0.2
};
TouchableOpacity.propTypes = { ...GenericTouchable.publicPropTypes,
  style: PropTypes.any,
  activeOpacity: PropTypes.number
};